<template>
  <v-container fluid>
    <v-form @submit.prevent="submit">
      <v-card class="mb-4">
        <v-card-title v-if="cart.documents.length > 1"
                      class="pb-0">
          Where do you want to put these documents?
        </v-card-title>
        <v-card-title v-else
                      class="pb-0">
          Where do you want to put this document?
        </v-card-title>
        <v-treeview dense
                    :active="activeFolders"
                    :items="rootFolders"
                    item-key="id"
                    item-text="name"
                    item-children="children"
                    item-disabled="veeva_disabled"
                    activatable
                    hoverable
                    :open-all="false"
                    :multiple-active="false"
                    @update:active="selectFolder">
          <template v-slot:prepend="{item, active, open}">
            <v-icon v-if="item.is_home">
              fas fa-home
            </v-icon>
            <v-icon v-else-if="active || open">
              fas fa-folder-open
            </v-icon>
            <v-icon v-else>
              fas fa-folder
            </v-icon>
          </template>
        </v-treeview>
        <v-alert v-if="form.errors.any()"
                 type="error"
                 tile>
          {{ form.errors.get('folder') }}
        </v-alert>
      </v-card>

      <v-card v-if="form.folder && form.folder !== -1"
              class="mb-4">
        <v-card-text>
          <v-switch v-model="form.showInMainList"
                    label="Also show in the home folder (The main screen in the iOS app)"
                    hide-details
                    class="mt-0">
          </v-switch>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-title v-if="cart.documents.length > 1"
                      class="pb-0">
          Which labels will be applied to these documents?
        </v-card-title>
        <v-card-title v-else
                      class="pb-0">
          Which labels will be applied to this document?
        </v-card-title>
        <v-card-text>
          <div style="max-height: 200px; overflow-y: auto;">
            <v-checkbox v-for="label in labels"
                        :key="label.id"
                        v-model="form.labels"
                        :value="label.id"
                        :label="label.name"
                        dense
                        hide-details>
            </v-checkbox>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent="$store.dispatch('vaultCart/prevStep')">
            Go back
          </v-btn>
          <v-btn type="submit"
                 color="primary"
                 :disabled="!form.folder">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import VaultImportStepper from './components/Stepper';

export default {
  name: 'vault-import-folders',
  components: {VaultImportStepper},
  data() {
    return {
      form: new Form({
        folder: null,
        showInMainList: false, // MLD-3968
        folders: [],
        labels: [],
      })
    }
  },
  computed: {
    ...mapGetters([
      'labels',
    ]),
    ...mapGetters('content', [
      'rootFolders',
    ]),
    ...mapGetters('vaultCart', [
      'cart',
    ]),
    activeFolders() {
      if (this.cart.folder) {
        return [this.cart.folder];
      }
      return [];
    },
  },
  created() {
    this.$store.dispatch('fetchFolders');
    this.$store.dispatch('fetchLabels');
    this.initForm();
  },
  methods: {
    initForm() {
      this.form.folder = this.cart.folder;
      this.form.labels = this.cart.labels;
    },
    selectFolder(folderIDs) {
      if (folderIDs.length) {
        this.form.folders = folderIDs;
        this.form.folder = folderIDs[0];
        if (folderIDs.length === 1 && this.form.folder === -1) { // MLD-6961
          this.form.showInMainList = true;
        }
      } else {
        this.form.folders = [];
        this.form.folder = null;
        this.form.showInMainList = true; // MLD-6961
      }
    },
    submit() {
      this.form.clear();
      this.$store.dispatch('vaultCart/setFolder', this.form.folder);
      this.$store.dispatch('vaultCart/setShowInMainList', this.form.showInMainList); // MLD-3968
      this.$store.dispatch('vaultCart/setLabels', this.form.labels);

      if (this.cart.folder) {
        this.$store.dispatch('vaultCart/nextStep');
      } else {
        this.form.errors.set('folder', 'You must select a folder.');
      }
    }
  }
}
</script>
